import mitt from 'mitt';
/**
 * Глобальная шина событий, используется для обмена событиями между компонентами.
 * Например, для открытия диалогов, обновления данных и т.д.
 * Основана на библиотеке mitt.
 * @type {import('mitt').Emitter}
 */
const emitter = mitt();
export default emitter;